












































import { Component, Watch, Vue } from 'vue-property-decorator'

@Component({})
export default class InfosCollapse extends Vue {
    infosOpened: boolean = true
    $collapse: any = null

    mounted() {
        const infosOpenedStr = localStorage.getItem('infosOpened')
        if (infosOpenedStr) {
            const infosOpened = JSON.parse(infosOpenedStr)
            this.infosOpened = infosOpened
        }

        this.$collapse = $(this.$refs.collapse) as any
        this.$collapse.on('shown.bs.collapse', this.onCollapseShown)
        this.$collapse.on('hidden.bs.collapse', this.onCollapseHidden)
    }

    destroyed() {
        this.$collapse.off('shown.bs.collapse', this.onCollapseShown)
        this.$collapse.off('hidden.bs.collapse', this.onCollapseHidden)
    }

    onCollapseShown() {
        this.infosOpened = true
    }

    onCollapseHidden() {
        this.infosOpened = false
    }

    @Watch('infosOpened')
    onInfosOpened() {
        const infosOpenedStr = JSON.stringify(this.infosOpened)
        localStorage.setItem('infosOpened', infosOpenedStr)
    }
}
